import React, { Component, useState } from 'react'
import SRCards from '../../components/SRCards'
import {
    Button, Container, FormControl, InputLabel, Select, MenuItem, Paper, TableContainer, TextField, Table,
    TableHead, TableRow, TableCell, TableBody, TableFooter,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Typography
} from '@material-ui/core'
import { CheckBox } from '@material-ui/icons'
// const apiservices = new TicketApi();
// import './qbsync.css';
import CommonServiceApi from '../../services/common-service';
import { flatMap, map } from 'lodash';
import { Alert } from '@material-ui/lab';
import { CHECK_VALUE } from '../../common/data-validator';
import SelectCompany from '../../components/SelectCompany';

export default function QBSyncList() {
    const [collectionNameToBeUpdated, setCollectionToBeUpdated] = useState('');
    const [entityIds, setEntityIds] = useState([]);
    const [keys, setKeys] = useState('');
    const [dialog, setDialog] = useState(false);
    const [snackBar, setSnackBar] = useState('');
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pageResponse, setPageResponse] = useState('');
    const [errorDialog, setErrorDialog] = useState(false);
    const apiservices = new CommonServiceApi();
    const SETTING_NAME_TO_URL_MAP = {
        ticket: "api/setting/ticketSettings",
        tax: "api/setting/taxSettings",
        timecard: "api/setting/timecardSettings",
        invoice: "api/setting/invoiceSettings",
        invoicePdf: "api/setting/invoicePDFSettings",
        customer: "api/setting/customerSettings",
        generic: "api/setting/genericSettings",
        callIntegration: "api/setting/callIntegrationSettings",
        quickBooks: "api/setting/quickbookSettings",
        payment: "api/setting/paymentSettings",
        priceBook: "api/setting/pricebookSettings",
        estimate: "api/setting/estimateSettings",
        notification: "api/setting/notificationSettings"
      };
    const handleChange = (e: any) => {
        if (e.target.value === 1) {
            setCollectionToBeUpdated('ticket');
        }
        else if (e.target.value === 2) {
            setCollectionToBeUpdated('invoice');
        }
        else if (e.target.value === 3) {
            setCollectionToBeUpdated('invoicePdf');
        }
        else if (e.target.value === 4) {
            setCollectionToBeUpdated('payment');
        }
        else if (e.target.value === 5) {
            setCollectionToBeUpdated('timecard');
        }
        else if (e.target.value === 6) {
            setCollectionToBeUpdated('generic');
        }
        else if (e.target.value === 7) {
            setCollectionToBeUpdated('quickBooks');
        }
        else if (e.target.value === 8) {
            setCollectionToBeUpdated('priceBook');
        }
        else if (e.target.value === 9) {
            setCollectionToBeUpdated('callIntegration');
        }
        else if (e.target.value === 10) {
            setCollectionToBeUpdated('tax');
        }else if (e.target.value === 11){
            setCollectionToBeUpdated('customer');
        }
    }

    const confirm = (e: any) => {
        if (CHECK_VALUE(collectionNameToBeUpdated) && CHECK_VALUE(keys)) {
            let res = `This operation will update the  data in the selected settings. Are you sure?`
            setDialog(true);
            setConfirmMsg(res);
        }
        else {
            setErrorDialog(true);
        }
        return
    }

    const cancel = () => {
        setDialog(false);
        setSnackBar('info');
        setPageResponse(`Update Settings Cancelled.`);
    }

    const update = async () => {
      try {
        let companyId = localStorage.getItem("selectedCompanyId");
        let response = await apiservices.updateSettings(
          { ...JSON.parse(keys), companyId: Number(companyId) },
          collectionNameToBeUpdated
        );
        if (response) {
          setDialog(false);
          setSnackBar("success");
          setPageResponse("Updated Successfully.");
        }
      } catch (error) {
        setDialog(false);
        setSnackBar("error");
        setPageResponse(`Update Failed, error: ${error}`);
        return;
      }
    };

    const onClose = () => {
        setErrorDialog(false)
    }

    const handleKeysToUpdate = (e: any) => {
        // let val = JSON.parse(e.target.value)
        setKeys(e.target.value);
    }

    const handleEntityIds = (e: any) => {
        let val = e.target.value;
        setEntityIds(val.split(',').map((str: any)=> Number(str)));
    }

    return (
        <>
            <SRCards />
            <Container>
                <SelectCompany/>
                <br /> <br />
                <Button className='qbsync_body'
                    onClick={confirm}
                    style={{ margin: 10 }}
                    variant='outlined'> Update </Button>
                <br></br><br></br>
                <FormControl fullWidth className='qbsync_body'>
                    <InputLabel id="demo-simple-select-label">Collection Name</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        label="Age"
                        onChange={handleChange}
                    >
                        <MenuItem value={1}>Ticket Settings</MenuItem>
                        <MenuItem value={2}>Invoice Settings</MenuItem>
                        <MenuItem value={3}>Invoice Pdf Settings</MenuItem>
                        <MenuItem value={4}>Payment Settings</MenuItem>
                        <MenuItem value={5}>Timecard Settings</MenuItem>
                        <MenuItem value={6}>Generic Settings</MenuItem>
                        <MenuItem value={7}>QuickBooks Settings</MenuItem>
                        <MenuItem value={8}>PriceBooks Settings</MenuItem>
                        <MenuItem value={9}>CallIntegration Settings</MenuItem>
                        <MenuItem value={10}>Tax Settings</MenuItem>
                        <MenuItem value={11}>Customer Settings</MenuItem>
                    </Select>
                    
                </FormControl>
                <br /> <br /> <br /> <br />
                <TextField
                    fullWidth
                    id="outlined-textarea"
                    label="Keys To Update"
                    placeholder="json value expected"
                    multiline
                    rows={4}
                    variant="filled"
                    onChange={handleKeysToUpdate}
                />
                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {'Confirmation!'}
                    </DialogTitle>
                    <DialogContent>
                        {confirmMsg}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={
                                () => {
                                    setConfirmMsg('Processing...')
                                    update()
                                }
                            }
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={
                                () => cancel()
                            }
                            autoFocus
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={errorDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        Please complete information before syncing.
                    </DialogContent>
                    <Button onClick={onClose}>Ok</Button>
                </Dialog>
                <Snackbar
                    open={snackBar === '' ? false : true}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar(snackBar);
                    }}
                >
                    <Alert
                        severity={snackBar === 'error' ? 'error' : 'success'}
                        onClose={() => {
                            setSnackBar(snackBar);
                        }
                        }>
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}
